export default (validator, suggestionMessage = null) => function deprecated(props, propName, ...rest) {
  if (props[propName] != null) {
    // eslint-disable-next-line no-console
    console.warn(`${propName} is deprecated.${suggestionMessage ? ` ${suggestionMessage}` : ''}`)
  }
  return validator(props, propName, ...rest)
}
